module.exports = __webpack_public_path__ + "static/media/icon_event_yellow_card.f7829fa5.svg";